import { cn } from "@/lib/utils";

/** Fixed app sidebar widths — must match `AppSidebar` (`w-[240px]` / `w-[64px]`). */
export const APP_SIDEBAR_WIDTH_EXPANDED_PX = 240;
export const APP_SIDEBAR_WIDTH_COLLAPSED_PX = 64;

/**
 * Header action labels show at this container min-width (`@[1000px]:inline`).
 * QA 1026 viewport minus expanded sidebar 240 = 786 header, so labels hide below 1000px container.
 */
export const HEADER_ACTION_LABEL_MIN_CONTAINER_PX = 1000;

/**
 * Main content column beside the fixed sidebar. Uses explicit width (not `flex-1`) so the
 * column never extends past the viewport when `margin-left` clears the sidebar.
 */
export function appLayoutMainColumnClassName(sidebarCollapsed: boolean): string {
  return cn(
    "flex min-w-0 flex-col transition-[margin,width] duration-200",
    sidebarCollapsed
      ? "ml-[64px] w-[calc(100%-64px)]"
      : "ml-[240px] w-[calc(100%-240px)]",
  );
}
